const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import * as telegram from './telegram'
import * as utils from './utils'
import { BaseObject, MongoObject } from './_baseClasses'

// TODO: Offer, Listing, Alert
export enum clickType {
  Deal = 0, GoneDeal = 1, Offer = 2, Listing = 3, Alert = 4
}

export class Click extends MongoObject {
  protected static collectionName: string = 'clicks'           // IMPORTANT

  public type: clickType = null       // e.g. Deals, Offers, Listings, Alert
  public clicker?: string = null      // flow address of person who clicked
  public itemID?: number = null       // e.g. offerID, momentID, etc 
  public value?: number = null        // e.g. dollar amount of deal, offer, etc
  public isFlowty?: boolean = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, type?: clickType, clicker?: string, itemID?: number, value?: number, isFlowty?: boolean) {
    super()
    if (po) this.injectPlainObject(po)
    if (type !== null && type !== undefined) this.type = type
    if (clicker) this.clicker = clicker
    if (itemID) this.itemID = itemID
    if (value) this.value = value
    if (isFlowty !== null && isFlowty !== undefined) this.isFlowty = isFlowty
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

  public isSafe(): boolean {
    return true
  }


}




(async () => {
})();
